import React from 'react';
import PropTypes from 'prop-types';

import SeeAllButton from './SeeAllButton';
import SectionHeader from './SectionHeader';
import UnifiedPostCard from '../../../components/UnifiedPostCard/UnifiedPostCard';
import { getUrl } from '../getUrl';
import { SEARCH_RESULTS } from '../constants';

const typesMap = [
    {
        type: 'community',
        text: 'From the Community',
    },
    {
        type: 'editorial_content',
        text: 'Articles',
    },
];

const CommunityResults = ({ results, searchBarTerm, isSingleSearch }) => {
    return typesMap.reduce((aggregate, { type, text }) => {
        if (results[type]?.total) {
            const { total, results: resultSet } = results[type];
            const url = getUrl(type, searchBarTerm);

            return [
                ...aggregate,
                <div key={type}>
                    <SectionHeader>
                        {text} ({total})
                    </SectionHeader>
                    {(resultSet || []).map((content) => (
                        <div key={content.hash}>
                            <UnifiedPostCard
                                {...content}
                                location={SEARCH_RESULTS}
                                showReactionBar={false}
                                showComments={false}
                                showAuthor={false}
                                hideModerationMenu
                            />
                        </div>
                    ))}
                    <SeeAllButton
                        text={`See all ${total} ${text}`}
                        type={type}
                        url={url}
                        isSingleSearch={isSingleSearch}
                    />
                </div>,
            ];
        }

        return aggregate;
    }, []);
};

export default CommunityResults;

const ReactionBarPropType = PropTypes.shape({
    active: PropTypes.bool,
    enabled: PropTypes.bool,
    icon: PropTypes.string,
    label: PropTypes.string,
    showCount: PropTypes.bool,
});

const CommunityResultPropTypes = PropTypes.shape({
    canComment: PropTypes.bool,
    contentUrl: PropTypes.string,
    hash: PropTypes.string,
    location: PropTypes.string,
    reactionBar: PropTypes.shape({
        liking: ReactionBarPropType,
        flagging: ReactionBarPropType,
        commenting: ReactionBarPropType,
        sharing: ReactionBarPropType,
    }),
    shell: PropTypes.string,
    title: PropTypes.string,
    topic: PropTypes.shape({
        url: PropTypes.string,
        isActive: PropTypes.number,
        label: PropTypes.string,
    }),
    type: PropTypes.string,
});

CommunityResults.propTypes = {
    results: PropTypes.shape({
        community: PropTypes.shape({
            results: PropTypes.arrayOf(CommunityResultPropTypes),
            total: PropTypes.number,
        }),
    }),
    searchBarTerm: PropTypes.string,
    isSingleSearch: PropTypes.bool,
};

CommunityResults.defaultProps = {
    results: {
        community: {
            results: [],
            total: null,
        },
    },
    searchBarTerm: null,
    isSingleSearch: false,
};
